import { ContextualMenu, DefaultButton, Dialog, DialogFooter, DialogType, Dropdown, PrimaryButton, Stack } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';
import React from 'react';
import { useBoolean } from 'react-use';
import { IPersonalPreferencesState } from './PersonalPreferences.State';

const PersonalPreferencesView: React.FC<IPersonalPreferencesState> = (props) => {
    const { switchLanguage, hideDialog, toggleHideDialog, language, setLanguage, showLanguage, openDialogBox } = props;

    const [isDraggable] = useBoolean(false);

    const dialogContentProps = {
        type: DialogType.normal,
        title: IvicosStrings.languageSelectionActionTitle,
        closeButtonAriaLabel: 'Close',
        subText: IvicosStrings.languageSelectionDescription
    };

    const modalPropsStyles = { main: { maxWidth: 450 } };

    const dragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };

    const modalProps = React.useMemo(
        () => ({
            isBlocking: true,
            styles: modalPropsStyles,
            dragOptions: isDraggable ? dragOptions : undefined
        }),
        [isDraggable]
    );

    return (
        <>
            <Stack tokens={{ childrenGap: 15 }}>
                <Stack style={{ padding: '5px 5px 5px 0px' }}>
                    <Dropdown
                        aria-label="Select-language"
                        label={IvicosStrings.languageSelectionLabel}
                        placeholder={showLanguage()}
                        options={[
                            { key: 'en', text: 'English', data: 'en' },
                            { key: 'de', text: 'Deutsch', data: 'de' }
                        ]}
                        onChange={(e, i) => {
                            openDialogBox(i && i.data);
                            // toggleHideDialog();
                            setLanguage(i && i.data);
                        }}
                        selectedKey={showLanguage()}
                    ></Dropdown>
                </Stack>
            </Stack>
            <Dialog hidden={hideDialog} onDismiss={toggleHideDialog} dialogContentProps={dialogContentProps} modalProps={modalProps}>
                <DialogFooter>
                    <DefaultButton
                        text={IvicosStrings.noAction}
                        onClick={() => {
                            toggleHideDialog();
                        }}
                        aria-label="cancel-change-language-button"
                    />
                    <PrimaryButton
                        text={IvicosStrings.yesAction}
                        onClick={() => {
                            switchLanguage(language);
                        }}
                        aria-label="change-language-button"
                    />
                </DialogFooter>
            </Dialog>
        </>
    );
};

export default PersonalPreferencesView;
